module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAaVBMVEUAAACZmZmZmZmXl5eZmZmZmZmZmZmZmZmYmJiZmZmampqZmZmZmZmZmZmampqbm5uVlZWZmZmZmZmampqZmZmZmZmampqbm5ubm5uampqWlpaZmZmampqZmZmampqampqXl5eZmZmZmZnDbRakAAAAInRSTlMAlPkF8x7OunxqZP3mcjwuENzBtKqcXllSSRfIoYd+dzYZnXRd6gAAAKhJREFUKM+t0FcOwjAQRVH3OD2QTmf2v0gSF6xo5g/u77El+7G/pOtxzC+0WQFbKqfsDqEaW1tGFBohh28PhNeEPUKTMEM4JOQIl4QNQ52jDQzXBe07RiSLrKqymV628EeIdd+3EpxaELw72qr2zfW24r5+dXjvXIbfS+PnXZM1Any5BZ9qo8kThJSAkJEBn0BUpIs44/EFZNphTePkkNNoHU6cbGE/9AHtYCQXR+X2YAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/userName.png
// module id = L8ce
// module chunks = 44